/* eslint-disable react-native/no-color-literals */
import { colors } from "colors"
import { Dimensions, StyleSheet } from "react-native"
import { typography } from "theme"

export const style = StyleSheet.create({
  barcodeContainer: { marginBottom: 20 },
  barcodeText: { fontFamily: typography.primary.normal, fontSize: 16, marginTop: 10 },
  container: {
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: "white",
    borderRadius: 10,
    justifyContent: "center",
    marginTop: 20,
    width: "85%",
    padding: 10,
    shadowColor: "rgba(0, 0, 0, 0.7)", // Adds a shadow color
    shadowOffset: { width: 0, height: 10 }, // Makes the shadow "float"
    shadowOpacity: 0.5, // Adjusts shadow visibility
    shadowRadius: 20, // Gives a magical blur effect
    elevation: 15, // Ensures compatibility on Android
  },

  descriptionContainer: { textAlign: "center" },
  fullcontainer: {
    alignItems: "center",
    height: "100%",
    justifyContent: "center",
  },
  membershipIdText: {
    color: "white",
    fontFamily: typography.primary.normal,
    marginTop: 10,
  },
  membershipNumberContainer: {
    alignItems: "center",
    borderRadius: 10,
    marginTop: 20,
    padding: 20,
    width: "100%",
  },
  modalBarcode: {
    alignItems: "center",
    backgroundColor: colors.white,
    height: "100%",
    justifyContent: "center",
    width: "100%",
  },
  modalCloseButton: { color: colors.black, position: "absolute", right: 10, top: 10, zIndex: 1 },
  modalContainer: {
    alignItems: "center",
    alignSelf: "center",
    backgroundColor: colors.white,
    borderRadius: 10,
    height: "100%",
    justifyContent: "center",
    maxWidth: 800,
    width: "100%",
  },
  modalQr: {
    alignItems: "center",
    backgroundColor: colors.white,
    height: Dimensions.get("window").width,
    justifyContent: "center",
    width: "100%",
  },
  titleText: { fontFamily: typography.primary.normal, fontSize: 25, textAlign: "center" },
  titleTextContainer: { alignItems: "center", marginVertical: 20 },
  ball1: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.4,
    width: 100,
    height: 100,
    bottom: -20,
    left: -40,
  },
  ball2: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.2,
    width: 70,
    height: 70,
    bottom: 35,
    left: 40,
  },
  ball3: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.5,
    width: 130,
    height: 130,
    bottom: -50,
    right: -50,
  },
  ball4: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 80,
    height: 80,
    bottom: 30,
    right: 40,
  },
  ball5: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.4,
    width: 90,
    height: 90,
    bottom: -50,
    left: 60,
  },
  ball6: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 50,
    height: 50,
    bottom: -30,
    right: 120,
  },
  ball7: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 75,
    height: 75,
    bottom: -15,
    right: 60,
  },
  ball8: {
    backgroundColor: colors.white,
    borderRadius: 99,
    position: "absolute",
    zIndex: -99,
    opacity: 0.3,
    width: 50,
    height: 50,
    bottom: -15,
    left: 40,
  },
})
